/**
 * 动态路由权限接入，请认真阅读文档进行接入
 * 文档地址： http://ued.zuoyebang.cc/documents/zk-fe-docs/#/admin/index?id=%e6%9d%83%e9%99%90%e7%ae%a1%e7%90%86
 */

import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/layout/index.vue'
import { UserModule } from '@/store/modules/user'

Vue.use(Router)

/*
  redirect:                      if set to 'noredirect', no redirect action will be trigger when clicking the breadcrumb
  meta: {
    title: 'title'               the name showed in subMenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon showed in the sidebar
    breadcrumb: false            if false, the item will be hidden in breadcrumb (default is true)
    hidden: true                 if true, this route will not show in the sidebar (default is false)
  }
*/

/**
 * @desc 路由守卫 只有管理员才可以进入的路由
 */
const needAdminAuth = async (to: any, from: any, next: Function) => {
  if (UserModule.hasLogin) {
    next()
  } else {
    next({ path: '/login' })
  }
}

const router = new Router({
  mode: 'history',
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/404',
      component: () => import(/* webpackChunkName: "404" */ '@/views/404.vue'),
      meta: { hidden: true, title: '404' }
    },
    {
      path: '/',
      component: Layout,
      redirect: '/home',
      children: [
        {
          path: 'home',
          component: () =>
            import(
              /* webpackChunkName: "dashboard" */ '@/views/home/index.vue'
            ),
          name: 'home'
        }
      ]
    },
    {
      path: '/app-stores',
      component: Layout,
      children: [
        {
          path: '',
          component: () => import('@/views/app-stores/index.vue'),
          name: 'Stores'
        }
      ]
    },
    {
      path: '/app-info',
      component: Layout,
      children: [
        {
          path: '',
          component: () => import('@/views/app-info/index.vue'),
          name: 'AppInfo'
        }
      ]
    },
    {
      path: '/application',
      component: () => import('@/layout/Home.vue'),
      beforeEnter: needAdminAuth,
      name: '应用管理',
      children: [
        {
          path: '/',
          component: () => import('@/layout/Menu.vue'),
          name: '应用管理',
          children: [
            {
              path: '',
              redirect: '/myapp'
            },
            {
              path: 'info/:id',
              name: '应用信息',
              component: () => import('@/views/creatApp/index.vue')
            },
            {
              path: 'developer-config/:id',
              name: '开发配置',
              component: () =>
                import('@/views/application/developer-config/index.vue')
            },
            {
              path: 'api-manage/:id',
              component: () => import('@/views/api-manage/index.vue'),
              name: 'API管理',
              children: [
                {
                  path: '',
                  component: () => import('@/views/app-api-list/index.vue'),
                  name: 'API管理'
                },
                {
                  path: 'apiAuth',
                  component: () => import('@/views/api-auth/index.vue'),
                  name: 'ApiAuth'
                }
              ]
            }
          ]
        }
      ]
    },
    // 个人中心
    {
      path: '/user',
      component: () => import('@/layout/Home.vue'),
      beforeEnter: needAdminAuth,
      name: '个人中心',
      children: [
        {
          path: '/',
          component: () => import('@/layout/Menu.vue'),
          name: '个人中心',
          children: [
            {
              path: '',
              redirect: 'account-safety'
            },
            {
              path: 'account-safety',
              name: '账号安全',
              component: () => import('@/views/user/account-safety/index.vue')
            },
            {
              path: 'institutional-info',
              name: '机构信息',
              component: () =>
                import('@/views/user/institutional-info/index.vue')
            }
          ]
        }
      ]
    },
    // 我的应用页面
    {
      path: '/myapp',
      beforeEnter: needAdminAuth,
      component: () => import('@/layout/Home.vue'),
      children: [
        {
          path: '',
          component: () => import('@/views/myapp/index.vue'),
          name: 'myapp'
        }
      ]
    },
    // 登录页
    {
      path: '/login',
      component: () => import('@/layout/Home.vue'),
      children: [
        {
          path: '',
          component: () => import('@/views/login/index.vue'),
          name: 'login'
        }
      ]
    },
    // 创建应用
    {
      path: '/creatApp',
      component: () => import('@/layout/Home.vue'),
      beforeEnter: needAdminAuth,
      name: '应用管理',
      children: [
        {
          path: '/',
          component: () => import('@/layout/Menu.vue'),
          name: '应用管理',
          children: [
            {
              path: '',
              name: '应用信息',
              component: () => import('@/views/creatApp/index.vue')
            }
          ]
        }
      ]
    },
    // 编辑应用
    {
      path: '/editApp/:id',
      component: () => import('@/layout/Home.vue'),
      beforeEnter: needAdminAuth,
      name: '应用管理',
      children: [
        {
          path: '/',
          component: () => import('@/layout/Menu.vue'),
          name: '应用管理',
          children: [
            {
              path: '',
              name: '应用信息',
              component: () => import('@/views/creatApp/index.vue')
            }
          ]
        }
      ]
    },
    {
      path: '/rules',
      component: () => import('@/views/rules/index.vue')
    },
    {
      path: '*',
      redirect: '/404',
      meta: { hidden: true }
    }
  ]
})

router.beforeEach(async function (to, from, next) {
  await UserModule.getUserInfo()
  next()
})
export default router
